<header class="c-header">
  <div class="header-wrapper">
    <a href="/" title="Graphisoft Careers Home" class="site-logo align-left">
      <img src="https://assets.graphisoft.com/logos/careers/careers_logo_black.svg" class="mobile-hide" alt="Graphisoft Careers Logo" />
      <img src="https://assets.graphisoft.com/logos/careers/careers_logo_mobile_black.svg" class="mobile-show" alt="Graphisoft Careers Logo" />
    </a>   
  </div>
  <!--<a href="https://career2.successfactors.eu/career?company=graphisoft&lang=en_US&loginFlowRequired=true" target="_blank" class="icon-user"></a>-->
  <app-language-selector></app-language-selector>
</header>
